(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-files', {
                parent: 'update_management',
                url: '/tab-files?search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files.html',
                        controller: 'TabFilesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    tabFileType: {
                        value: '-1'
                    },
                    tabObjectType: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            tabFileType: $stateParams.tabFileType,
                            tabObjectType: $stateParams.tabObjectType,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-files-upgrade', {
                parent: 'tab-files',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-upgrade.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', '$q', function ($stateParams, ScriptsReleases, $q) {
                        var scriptsRelease = $q.defer();
                        ScriptsReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            scriptsRelease.resolve(data);
                        });
                        return scriptsRelease.promise;
                    }]
                }
            })
            .state('tab-files-detail', {
                parent: 'tab-files',
                url: '/tab-files/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-detail.html',
                        controller: 'TabFilesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', function ($stateParams, TabFiles) {
                        return TabFiles.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-files-new', {
                parent: 'tab-files',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-dialog.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            fileAlias: null,
                            fileDescription: null,
                            fileName: null,
                            fileContent: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-files-edit', {
                parent: 'tab-files',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabFiles.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-files/tab-files-dialog.html',
                        controller: 'TabFilesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabFiles');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabFiles', function ($stateParams, TabFiles) {
                        return TabFiles.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-files.enable', {
                parent: 'tab-files',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-files/tab-files-enable-dialog.html',
                        controller: 'TabFilesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFiles', function (TabFiles) {
                                return TabFiles.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-files', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-files.delete', {
                parent: 'tab-files',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-files/tab-files-delete-dialog.html',
                        controller: 'TabFilesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabFiles', function (TabFiles) {
                                return TabFiles.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-files', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
